import { useParams } from "react-router-dom";
import { AllNotesDataTable } from "./AllNotesDataTable";


export const AllNotesPage = () => {

    const { noteId, scorecardId } = useParams() as { 
        noteId: string;
        scorecardId: string;
      };
    return (
        <AllNotesDataTable noteId={noteId} scorecardId={scorecardId}></AllNotesDataTable>
    );
}